import Paragraph from "@vfuk/core-paragraph";
import Spacing from "@vfuk/core-spacing";
import Span from "@vfuk/core-span";
import styled from "styled-components";

export const Subtext = ({ text }: { text: string }) => {
  return (
    <Spacing spacingLevel={{ top: 1, bottom: 3 }}>
      <Paragraph size={2} noMargin>
        <Span appearance="alt2">{text}</Span>
      </Paragraph>
    </Spacing>
  );
};

export const SelectNoMarginBottom = styled.div`
  .removeMarginBottom {
    margin-bottom: 0px;
  }
  .removeMarginBottom > div {
    margin-bottom: 0px;
  }
`;

export const InputNoMarginBottom = styled.div`
  div:first-child {
    margin-bottom: 0px;
  }
`;
